<template>
  <div>
    <b-table :current-page="currentPage"
             :fields="finalGradeHelpers.finalGradeReviewsFields"
             :items="proposalsFromProp"
             :per-page="perPage"
             :responsive="true"
             :sort-by="'document_specification.document_id'"
             :sort-desc='true'
             :tbody-tr-class="highlightOpenedProposals"
             class="table-responsive"
             details-td-class="pa-0"
             head-variant="light"
             hover
             striped>

      <template v-slot:top-row="{fields}">
        <proposal-filter :id="parent"
                         v-model="proposalsFromProp"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage, currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-action-expand-details :b-table-row="row"
                                    @click="handleDetailsShowing(row)"/>
      </template>

      <template v-slot:row-details="row">

        <base-details-container>
          <template v-slot:details-body>
            <base-reviews-details v-if="reviewersLoadingComplete"
                                  :constructed-reviews="constructReviews(row.item)"
                                  :is-rapid-access="true"/>
          </template>
        </base-details-container>

      </template>

    </b-table>
    <b-table-footer :current-page="currentPage"
                    :data-length="proposalsFromProp.length"
                    :per-page="perPage"
                    @change-page="currentPage=$event">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseActionExpandDetails from '@/components/actions/BaseActionExpandDetails';
  import ProposalFilter from '@/components/ProposalFilter';
  import BTableFooter from '@/components/BTableFooter';
  import BaseReviewsDetails from '@/components/base-components/BaseReviewsDetails';
  import BaseDetailsContainer from '@/components/base-components/BaseDetailsContainer';
  import { reviewsDetails } from '@/mixins/reviewsDetails';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { openedDetails } from '@/mixins/openedDetails';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'RapidAccessFinalGradeReviews',
    components: {
      BaseColumnOrdinalNumber,
      BaseActionExpandDetails,
      ProposalFilter,
      BTableFooter,
      BaseReviewsDetails,
      BaseDetailsContainer,
      BasePerPageInput,
    },
    props: {
      proposals: {
        type: Array,
        default: () => [],
      },
      // necessary for proposal filter feature
      parent: {
        type: Number,
        required: true,
      },
      // end
    },
    mixins: [reviewsDetails, infrastructureMixin, openedDetails],
    data() {
      return {
        // use only for visual effect and trigger event to filter component
        showFilter: false,

        // necessary for b-table feature
        currentPage: 1,
        perPage: 20,
        // end

        proposalsFromProp: this.proposals,
        finalGradeHelpers: {},

      };
    },
    watch: {
      proposalsFromProp: {
        handler(newValue) {
          this.$emit('filtered-proposals', newValue);
        },
      },
      proposals() {
        this.proposalsFromProp = this.proposals;
        this.$emit('setup-proposal', this.proposalsFromProp);
      },
    },
    async created() {
      const helpers = await this.getEvaluationDashboardProperties(this.infrastructure, 'FinalGrade');
      this.finalGradeHelpers = helpers.getAsObject(
        'finalGradeReviewsFields',
        'reviewsUrl',
      );
    },
  };
</script>

<style scoped>

</style>
